/* unplugin-vue-components disabled */import { render } from "./CreatePool.vue?vue&type=template&id=229d04f9"
import script from "./CreatePool.vue?vue&type=script&lang=js"
export * from "./CreatePool.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__